import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";

import Chatting from "../views/page/board/Chatting";
import Inquiry from "../views/page/board/Inquiry";
import InquiryWrite from "../views/page/board/InquiryWrite";
import Consult from "../views/page/board/Consult";
import ConsultWrite from "../views/page/board/ConsultWrite";

const LegacyBoardWriteRedirect = ({ boardPath }) => {
  const { board_seq } = useParams();

  return <Navigate to={`/Board/${boardPath}/Write/${board_seq}`} replace />;
};

function RouterBoard() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/Manage/Inquiry" replace />} />
        <Route exact path="/Chatting" element={<Chatting />} />
        <Route exact path="/Inquiry" element={<Inquiry />} />
        <Route exact path="/Inquiry/Write" element={<InquiryWrite />} />
        <Route exact path="/Inquiry/Write/:board_seq" element={<InquiryWrite />} />
        <Route exact path="/Consult" element={<Consult />} />
        <Route exact path="/Consult/Write" element={<ConsultWrite />} />
        <Route exact path="/Consult/Write/:consu_seq" element={<ConsultWrite />} />
        <Route exact path="/Notice" element={<Navigate to="/Board/Notice" replace />} />
        <Route exact path="/Notice/Write" element={<Navigate to="/Board/Notice/Write" replace />} />
        <Route exact path="/Notice/Write/:board_seq" element={<LegacyBoardWriteRedirect boardPath="Notice" />} />
        <Route exact path="/Faq" element={<Navigate to="/Board/Faq" replace />} />
        <Route exact path="/Faq/Write" element={<Navigate to="/Board/Faq/Write" replace />} />
        <Route exact path="/Faq/Write/:board_seq" element={<LegacyBoardWriteRedirect boardPath="Faq" />} />
      </Routes>
    </>
  );
}

export default RouterBoard;
